import { AppSettings } from "../../../entities/AppSettings";


export const appSettings: AppSettings = {
  authority: '',
  client_id: '',
  scope: '',
  apiServiceAddress: '',
  controllerRouteRoot: '/api',
  primaryUrl: '',
  secondaryUrl:''
};
